// extracted by mini-css-extract-plugin
export default {"container":"VerticalLabel_container__Ld7ak","content":"VerticalLabel_content__RwPms"};